import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';
import { OverlayTrigger, Tooltip } from '@saucelabs/sl-component-overlay';
import { format } from 'date-fns';
import ReactImageFallback from 'react-image-fallback';

import { AppRecord } from '../records';
import MobileAppDescription from './MobileAppDescription';
import ThumbnailAndroid from '../images/thumbnail-android.svg';
import ThumbnailIOS from '../images/thumbnail-iOS.svg';
import Styles from './MobileAppTableRow.styles';
import { LAST_CHANGE_TIME_FORMAT } from '../constants';

const MobileAppTableRow = ({ app, onClick }) => {
  const Thumbnail = app.platform === 'ANDROID' ? ThumbnailAndroid : ThumbnailIOS;

  return (
    <tr
      key={app.id}
      className={Styles.row}
      onClick={() => onClick(app)}
    >
      <td className={Styles.column}>
        <MobileAppDescription
          displayName={app.displayName}
          id={app.id}
          thumbnail={(
            <ReactImageFallback
              alt="app thumbnail"
              fallbackImage={<Thumbnail />}
              src={app.iconUrl}
            />
          )}
        />
      </td>
      <td className={Styles.column}>{app.version}</td>
      <td className={Styles.column}>
        <span className={Styles['os-icon']}>
          <PlatformIcon name={app.platform} />
          {app.getPrettyPlatform()}
        </span>
      </td>
      <td className={Styles.column}>
        <OverlayTrigger
          overlay={(
            <Tooltip id={`${app.id}-tooltip`}>
              {format(
                new Date(app.lastChange),
                LAST_CHANGE_TIME_FORMAT,
              )}

            </Tooltip>
          )}
          placement="top"
          rootClose
        >
          <span>
            {app.getPrettyLastChange()}
          </span>
        </OverlayTrigger>
      </td>
    </tr>
  );
};

MobileAppTableRow.propTypes = {
  app: ImmutablePropTypes.recordOf(AppRecord).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MobileAppTableRow;
